export default __webpack_public_path__ + "static/media/img-video-6.2668a872.png";